import React from 'react';
import './ConfirmActionModal.css';

const ConfirmActionModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Aceptar', cancelText = 'Cancelar' }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-action-overlay" onClick={onClose}>
      <div className="confirm-action-content" onClick={e => e.stopPropagation()}>
        <div className="confirm-action-header">
          <h3>{title || 'Confirmar accion'}</h3>
          <button className="confirm-action-close" onClick={onClose}>×</button>
        </div>
        <div className="confirm-action-body">
          <p>{message || '¿Estas seguro de que deseas realizar esta accion?'}</p>
        </div>
        <div className="confirm-action-footer">
          <button className="confirm-action-cancel" onClick={onClose}>
            {cancelText}
          </button>
          <button className="confirm-action-confirm" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal;